module.exports = __webpack_public_path__ + "static/veneer2-ad6ce2a1ef990fe5cff8c76f3e944174.jpg";